/**
 * IFC element type filter constants.
 * MGroup is stored in IFC file additional info (property_data.PSET_data.MGroup).
 * Aligned with importer-frontend exportConfig and constants.
 */

/** MGroup types that are directly exported to the backend (imported IFC types). */
export const directIfcExports = [
  'inner_walls',
  'outer_walls',
  'slabs',
  'roof_slabs',
  'columns',
  'beams',
  'openings',
] as const

/**
 * MGroup types that are only exported when their parent elements are included.
 */
export const indirectIfcExports = ['openings'] as const

/** Human-readable labels for known MGroup types (German). */
export const ifcElementTypeLabels: Record<string, string> = {
  inner_walls: 'Innenwand',
  outer_walls: 'Außenwand',
  slabs: 'Decken',
  openings: 'Öffnungen',
  roof_slabs: 'Dachflächen',
  columns: 'Stützen',
  beams: 'Träger',
  members: 'Bauteile',
  doors: 'Türen',
  windows: 'Fenster',
  furniture: 'Möbel',
  stairs: 'Treppen',
  unclassified: 'Nicht zugeordnet',
}

/**
 * MGroup types that appear in visibility filters but are not assignable element types (kept out of
 * `ifcElementTypeLabels` so the type-assignment dropdown does not offer them).
 */
const filterOnlyTypeLabels: Record<string, string> = {
  spaces: 'Räume',
  compositions: 'Baugruppen',
  tga: 'TGA',
  property: 'Gelände',
}

/** Labels for all MGroup types shown in visibility filters (assignable plus filter-only types). */
export const ifcFilterTypeLabels: Record<string, string> = {
  ...ifcElementTypeLabels,
  ...filterOnlyTypeLabels,
}

/** Preferred display order for IFC element types in filters/lists. */
export const ifcElementTypeLabelsOrder = [
  'walls',
  'outer_walls',
  'inner_walls',
  'slabs',
  'roof_slabs',
  'columns',
  'beams',
  'openings',
  'members',
  'doors',
  'windows',
  'furniture',
  'stairs',
  'property',
  'unclassified',
] as const

export type IfcElementType = keyof typeof ifcElementTypeLabels
